export default "__VITE_ASSET__LFwqOdjD__"